import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcTicketFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "25",
    fill: "none",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.5 4.53H4.75C3.23 4.53 2 5.721 2 7.192v2.094c0 .443.354.784.776.821 1.146.1 2.044 1.035 2.044 2.171s-.898 2.07-2.044 2.17c-.422.038-.776.38-.776.823v2.093c0 1.471 1.231 2.664 2.75 2.664H15.5v-1.45a.75.75 0 1 1 1.5 0v1.45h2.25c1.518 0 2.75-1.193 2.75-2.664V7.193c0-1.471-1.232-2.664-2.75-2.664H17v1.7a.75.75 0 0 1-1.5 0zM17 9.08a.75.75 0 0 0-1.5 0v1.9a.75.75 0 1 0 1.5 0zm0 4.75a.75.75 0 0 0-1.5 0v1.9a.75.75 0 1 0 1.5 0z",
    clipRule: "evenodd"
  }));
}
var IcTicketFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTicketFill));

export { IcTicketFill as I };
